import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-quartz.css';
import { SxProps } from '@mui/joy/styles/types';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
  provideGlobalGridOptions,
} from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { Dispatch, ReactElement, SetStateAction } from 'react';

import { useAgGridServerTableContext } from 'core/states';
import {
  ISelectionAction,
  ISelectionActionProps,
  ITableAction,
  ITableActionProps,
} from 'core/types';

import { Wrapper } from './style';
import TopActions from './TopActions';
import './style.css';

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY);

provideGlobalGridOptions({ theme: 'legacy' });

interface IProps {
  actions?: () => ITableAction[];
  selectionActions?: () => ISelectionAction[];
  closeSelection?: boolean;
  setCloseSelection?: Dispatch<SetStateAction<boolean>>;
  wrapperStyle?: SxProps;
  actionButtons?: ReactElement[] | ((props: ITableActionProps) => ReactElement[]);
  rightActionButtons?: ReactElement[];
  selectionActionButtons?: ReactElement[] | ((props: ISelectionActionProps) => ReactElement[]);
}

const AgGridServerTableView = ({
  actions,
  selectionActions,
  closeSelection = false,
  setCloseSelection,
  wrapperStyle = {},
  actionButtons = [],
  rightActionButtons = [],
  selectionActionButtons = [],
}: IProps) => {
  const {
    tableId,
    gridRef,
    gridApi,
    gridOptions,
    selectedRows,
    deselectAllRows,
    layoutType,
    hasLayoutActions,
    hasManageFilters,
    layoutChanged,
    resetMenuItems,
    onSaveLayout,
    entityType,
    hasQuickSearch,
    hasTopActions,
  } = useAgGridServerTableContext();

  return (
    <Wrapper id={tableId} className="ag-theme-quartz" sx={wrapperStyle}>
      {hasTopActions && (
        <TopActions
          actions={actions}
          actionButtons={actionButtons}
          rightActionButtons={rightActionButtons}
          selectionActions={selectionActions}
          selectionActionButtons={selectionActionButtons}
          selectionType={entityType}
          closeSelection={closeSelection}
          setCloseSelection={setCloseSelection}
          tableId={tableId}
          gridApi={gridApi}
          selectedRows={selectedRows}
          deselectAllRows={deselectAllRows}
          isDataLoading={false}
          isDataLoadCompleted={true}
          hasQuickSearch={hasQuickSearch}
          layoutType={layoutType}
          hasLayoutActions={hasLayoutActions}
          hasManageFilters={hasManageFilters}
          resetMenuItems={resetMenuItems}
          saveLayoutDisabled={!layoutChanged}
          onSaveLayout={onSaveLayout}
        />
      )}
      <AgGridReact ref={gridRef} {...gridOptions} />
    </Wrapper>
  );
};

export default AgGridServerTableView;
